(function () {
  function parseSampleMap(button) {
    const raw = button.getAttribute('data-sample-map');
    if (!raw) return {};

    try {
      return JSON.parse(raw);
    } catch (error) {
      return {};
    }
  }

  /** Resolves event.target to an Element so closest() is available (text nodes do not have it). */
  function eventTargetElement(target) {
    return target instanceof Element ? target : target.parentElement;
  }

  function updateSampleTriggerFromKey(button, sampleKey) {
    if (!button || !sampleKey) return;

    const holder = button.closest('.quick-add__holder--sample');
    const sampleMap = parseSampleMap(button);
    const sampleEntry = sampleMap[sampleKey];

    if (!sampleEntry || !sampleEntry.id) {
      if (holder) holder.hidden = true;
      return;
    }

    if (holder) holder.hidden = false;
    button.setAttribute('data-variant-id', String(sampleEntry.id));
    button.setAttribute('data-sample-active-key', sampleKey);
  }

  function initSampleTrigger(button) {
    const sampleMap = parseSampleMap(button);
    const mapKeys = Object.keys(sampleMap);
    if (!mapKeys.length) return;

    const activeKey = button.getAttribute('data-sample-active-key');
    if (activeKey && sampleMap[activeKey]) {
      updateSampleTriggerFromKey(button, activeKey);
      return;
    }

    updateSampleTriggerFromKey(button, mapKeys[0]);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sample-trigger]').forEach((button) => {
      initSampleTrigger(button);
    });
  });

  ['mouseenter', 'focusin', 'click'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        const swatch = eventTargetElement(event.target)?.closest('[data-swatch-button]');
        if (!swatch) return;

        const gridItem = swatch.closest('[data-grid-item]');
        const button = gridItem?.querySelector('[data-sample-trigger]');
        if (!button) return;

        const sampleKey = swatch.getAttribute('data-sample-key');
        updateSampleTriggerFromKey(button, sampleKey);
      },
      true
    );
  });

  if (!customElements.get('sample-order')) {
    customElements.define(
      'sample-order',
      class SampleOrder extends HTMLElement {
        connectedCallback() {
          this.productInfo = this.closest('product-info');
          this.form = this.querySelector('[data-sample-form]');
          this.button = this.querySelector('[data-sample-order-button]');
          this.variantInput = this.querySelector('[data-sample-variant-id]');
          this.single = this.querySelector('[data-sample-single]');
          this.options = this.querySelector('[data-sample-options]');
          this.optionList = this.querySelector('[data-sample-option-list]');
          this.optionName = this.options?.dataset.sampleOptionName || 'SampleSize';
          this.price = this.querySelector('[data-sample-price]');
          this.variants = this.parseVariants();
          this.candidates = [];
          this.activeSize = '';
          this.onProductChange = this.handleProductChange.bind(this);
          this.onSampleChange = this.handleSampleChange.bind(this);
          this.onSubmit = this.addToCart.bind(this);

          this.productInfo?.addEventListener('change', this.onProductChange);
          this.addEventListener('change', this.onSampleChange);
          this.form?.addEventListener('submit', this.onSubmit);
          this.update();
        }

        disconnectedCallback() {
          this.productInfo?.removeEventListener('change', this.onProductChange);
          this.removeEventListener('change', this.onSampleChange);
          this.form?.removeEventListener('submit', this.onSubmit);
        }

        parseVariants() {
          try {
            return JSON.parse(this.querySelector('[data-sample-variants]')?.textContent || '[]');
          } catch (error) {
            return [];
          }
        }

        selectedValue(optionIndex) {
          const wrapper = this.productInfo?.querySelector(`[data-option-position="${Number(optionIndex) + 1}"]`);
          const selected = wrapper?.querySelector('input:checked, [data-popout-input]');
          return selected?.value || '';
        }

        handleProductChange(event) {
          if (event.target.matches('[data-sample-size-option]')) return;
          this.update();
        }

        handleSampleChange(event) {
          const input = event.target.closest('[data-sample-size-option]');
          if (!input || !this.contains(input)) return;

          const match = this.candidates.find((variant) => String(variant.id) === input.value);
          if (!match) return;

          this.activeSize = match.size;
          this.syncActiveSample(match);
        }

        update() {
          const color = this.selectedValue(this.dataset.colorOptionIndex);
          const material = this.selectedValue(this.dataset.materialOptionIndex);
          this.candidates = this.variants.filter(
            (variant) => variant.color === color && variant.material === material
          );

          if (!this.candidates.length) {
            this.hidden = true;
            delete this.dataset.sampleLayout;
            this.form.hidden = true;
            this.variantInput.value = '';
            if (this.price) this.price.textContent = '';
            this.single.hidden = true;
            this.options.hidden = true;
            this.optionList.replaceChildren();
            return;
          }

          const active = this.candidates.find((variant) => variant.size === this.activeSize) || this.candidates[0];
          this.activeSize = active.size;
          this.dataset.sampleLayout = this.candidates.length === 1 ? 'single' : 'multiple';
          this.hidden = false;
          this.form.hidden = false;
          this.renderCandidates(active);
          this.syncActiveSample(active);
        }

        renderCandidates(active) {
          this.optionList.replaceChildren();

          if (this.candidates.length === 1) {
            this.single.textContent = active.size;
            this.single.hidden = false;
            this.options.hidden = true;
            return;
          }

          this.single.hidden = true;
          this.options.hidden = false;

          const fragment = document.createDocumentFragment();
          this.candidates.forEach((variant, index) => {
            const inputId = `${this.optionName}-${index}`;
            const label = document.createElement('label');
            const input = document.createElement('input');
            const text = document.createElement('span');

            label.className = 'product-sample-order__option';
            label.htmlFor = inputId;
            input.className = 'product-sample-order__option-input';
            input.type = 'radio';
            input.id = inputId;
            input.name = this.optionName;
            input.value = String(variant.id);
            input.checked = variant.id === active.id;
            input.dataset.sampleSizeOption = '';
            text.textContent = variant.size;

            label.append(input, text);
            fragment.append(label);
          });

          this.optionList.append(fragment);
        }

        syncActiveSample(active) {
          this.variantInput.value = active.id;
          if (this.price) this.price.textContent = active.price;
        }

        addToCart(event) {
          event.preventDefault();
          if (!this.variantInput.value || this.form.hidden || this.hidden) return;

          document.dispatchEvent(
            new CustomEvent('theme:cart:add', {
              detail: {button: this.button},
              bubbles: false,
            })
          );
          window.a11y.lastElement = this.button;
        }
      }
    );
  }
})();
